export default {
  cardholder_name: 'Nome e cognome',
  cardholder_name_placeholder: 'Nome sulla carta',
  card_number: 'Numero della carta',
  card_number_placeholder: '1234 5678 9012 3456',
  expiry: 'Data di scadenza',
  expiry_placeholder: 'MM / AA',
  cvv: 'Codice di sicurezza',
  cvv_label: 'Codice di sicurezza (CVC)',
  cvv_placeholder: 'CVC',
  loading: 'Inizializzazione del modulo carta sicuro…',
  sdk_load_failed: 'Impossibile caricare il modulo carta sicuro. Controlla la connessione e aggiorna la pagina.',
  errors: {
    number_blank: 'Inserisci il numero della tua carta.',
    number_invalid: 'Questo numero di carta non è valido. Controlla le cifre e riprova.',
    number_incomplete: 'Il numero della carta è incompleto.',
    cvv_blank: 'Inserisci il codice di sicurezza sul retro della carta.',
    cvv_invalid: 'Questo codice di sicurezza non è valido. Controlla le 3 o 4 cifre sulla carta.',
    cvv_incomplete: 'Inserisci tutte le {{count}} cifre del codice di sicurezza.',
    expiry_invalid: 'Inserisci una data di scadenza valida nel formato MM / AA.',
    expired: "Questa carta è scaduta. Usa un'altra carta.",
    name_blank: 'Inserisci il nome esattamente come riportato sulla carta.',
    configuration: 'I pagamenti con carta non sono disponibili al momento. Prova un altro metodo di pagamento.',
    generic: 'Non è stato possibile verificare i dati della carta. Riprova.',
  },
};
